'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _InvoiceForm = require('./InvoiceForm.style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintInvoiceForm = function PrintInvoiceForm(_ref) {
  var printInvoiceDetails = _ref.printInvoiceDetails,
      localization = _ref.localization,
      language = _ref.language;
  var PatientName = printInvoiceDetails.PatientName,
      reservationDate = printInvoiceDetails.reservationDate,
      patientMobileNumber = printInvoiceDetails.patientMobileNumber,
      invoiceItemsList = printInvoiceDetails.invoiceItemsList,
      invoiceSummary = printInvoiceDetails.invoiceSummary,
      localizedCurrency = printInvoiceDetails.localizedCurrency,
      providerInfo = printInvoiceDetails.providerInfo,
      providerName = printInvoiceDetails.providerName,
      addressString = printInvoiceDetails.addressString,
      taxID = printInvoiceDetails.taxID,
      crNumber = printInvoiceDetails.crNumber;


  var rountUpTo2Decimals = function rountUpTo2Decimals(number) {
    if (number) return Math.round(number * 100) / 100;
    return 0;
  };

  return _react2.default.createElement(
    _InvoiceForm.Wrapper,
    { language: language },
    _react2.default.createElement(
      'div',
      { className: 'invoice' },
      _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'details-container' },
            _react2.default.createElement(
              'div',
              { className: 'details margin-title' },
              providerInfo.providerLogo ? _react2.default.createElement('img', { className: 'logo', src: providerInfo.providerLogo, alt: 'entityLogo' }) : ''
            ),
            _react2.default.createElement(
              'div',
              { className: 'details2' },
              _react2.default.createElement(
                'p',
                { className: 'bold-invoice-title ' + (language === 'en' ? '' : 'ar') },
                localization.invoice
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'details-container ' + (language === 'en' ? '' : 'details-container-ar') },
            _react2.default.createElement(
              'div',
              { className: 'details' },
              _react2.default.createElement(
                'p',
                { className: 'bold-title ' + (language === 'en' ? '' : 'ar') },
                localization.details
              ),
              _react2.default.createElement(
                'p',
                { className: 'light-detail ' + (language === 'en' ? '' : 'ar') },
                providerName
              ),
              invoiceSummary.invoiceNumber ? _react2.default.createElement(
                'p',
                { className: 'light-detail ' + (language === 'en' ? '' : 'ar') },
                localization.invoiceNo,
                ' ',
                invoiceSummary.invoiceNumber
              ) : '',
              crNumber ? _react2.default.createElement(
                'p',
                { className: 'light-detail ' + (language === 'en' ? '' : 'ar') },
                localization.crNumber,
                ' ',
                crNumber
              ) : '',
              taxID ? _react2.default.createElement(
                'p',
                { className: 'light-detail ' + (language === 'en' ? '' : 'ar') },
                localization.taxId,
                ' ',
                taxID
              ) : '',
              _react2.default.createElement(
                'p',
                { className: 'light-detail ' + (language === 'en' ? '' : 'ar') },
                localization.date,
                ' ',
                reservationDate
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'details2 margin-title' },
              _react2.default.createElement(
                'p',
                { className: 'bold-title ' + (language === 'en' ? '' : 'ar') },
                localization.billTo
              ),
              _react2.default.createElement(
                'p',
                { className: 'light-detail ' + (language === 'en' ? '' : 'ar') },
                PatientName
              ),
              _react2.default.createElement(
                'p',
                { className: 'light-detail ' + (language === 'en' ? '' : 'ar ar-phone') },
                patientMobileNumber
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'table-container ' + (language === 'en' ? '' : 'details-container-ar') },
            _react2.default.createElement(
              'div',
              { className: 'table-header' },
              _react2.default.createElement(
                'p',
                { className: 'bold-title table-first-item col0 ' + (language === 'en' ? '' : 'ar') },
                localization.description
              ),
              _react2.default.createElement(
                'p',
                { className: 'bold-title table-middle-item col1 ' + (language === 'en' ? '' : 'ar') },
                localization.qty
              ),
              _react2.default.createElement(
                'p',
                { className: 'bold-title table-middle-item col2 ' + (language === 'en' ? '' : 'ar') },
                localization.price
              ),
              _react2.default.createElement(
                'p',
                { className: 'bold-title table-middle-item col3 ' + (language === 'en' ? '' : 'ar') },
                localization.insuranceCoverage
              ),
              _react2.default.createElement(
                'p',
                { className: 'bold-title table-last-item col4 ' + (language === 'en' ? '' : 'ar') },
                localization.amount
              )
            ),
            _react2.default.createElement('div', { className: 'bold-separator' }),
            invoiceItemsList && invoiceItemsList.length && invoiceItemsList.map(function (item) {
              return _react2.default.createElement(
                'div',
                { className: 'table-row' },
                _react2.default.createElement(
                  'p',
                  {
                    className: 'light-detail table-first-item col0 ' + (language === 'en' ? '' : 'ar')
                  },
                  item.description
                ),
                _react2.default.createElement(
                  'p',
                  {
                    className: 'light-detail table-middle-item col1 ' + (language === 'en' ? '' : 'ar')
                  },
                  item.qty
                ),
                _react2.default.createElement(
                  'p',
                  {
                    className: 'light-detail table-middle-item col2 ' + (language === 'en' ? '' : 'ar')
                  },
                  item.price,
                  ' ',
                  localizedCurrency
                ),
                _react2.default.createElement(
                  'p',
                  {
                    className: 'light-detail table-middle-item col3 ' + (language === 'en' ? '' : 'ar')
                  },
                  rountUpTo2Decimals(item.insuranceCoverge),
                  ' ',
                  localizedCurrency
                ),
                _react2.default.createElement(
                  'p',
                  {
                    className: 'light-detail table-last-item col4 ' + (language === 'en' ? '' : 'ar')
                  },
                  rountUpTo2Decimals(item.amount),
                  ' ',
                  localizedCurrency
                )
              );
            }),
            _react2.default.createElement('div', { className: 'bold-separator' }),
            _react2.default.createElement(
              'div',
              {
                className: 'summary-container ' + (language === 'en' ? '' : 'details-container-ar')
              },
              _react2.default.createElement(
                'div',
                { className: 'summary-wrapper' },
                _react2.default.createElement(
                  'div',
                  { className: 'summary-item' },
                  _react2.default.createElement(
                    'p',
                    { className: 'light-detail ' + (language === 'en' ? '' : 'ar') },
                    localization.subTotal
                  ),
                  _react2.default.createElement(
                    'p',
                    { className: 'light-detail ' + (language === 'en' ? '' : 'ar') },
                    rountUpTo2Decimals(invoiceSummary.subTotal),
                    ' ',
                    localizedCurrency
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'summary-item' },
                  _react2.default.createElement(
                    'p',
                    { className: 'light-detail ' + (language === 'en' ? '' : 'ar') },
                    localization.discount
                  ),
                  _react2.default.createElement(
                    'p',
                    { className: 'light-detail ' + (language === 'en' ? '' : 'ar') },
                    rountUpTo2Decimals(invoiceSummary.discount),
                    ' ',
                    localizedCurrency
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'summary-item' },
                  _react2.default.createElement(
                    'p',
                    { className: 'light-detail ' + (language === 'en' ? '' : 'ar vat') },
                    localization.vat
                  ),
                  _react2.default.createElement(
                    'p',
                    { className: 'light-detail ' + (language === 'en' ? '' : 'ar') },
                    rountUpTo2Decimals(invoiceSummary.vat),
                    ' ',
                    localizedCurrency
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'summary-item total-item' },
                  _react2.default.createElement(
                    'p',
                    { className: 'bold-title-big ' + (language === 'en' ? '' : 'ar') },
                    localization.total
                  ),
                  _react2.default.createElement(
                    'p',
                    { className: 'bold-title-big ' + (language === 'en' ? '' : 'ar') },
                    rountUpTo2Decimals(invoiceSummary.total),
                    ' ',
                    localizedCurrency
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'details-container footer ' + (language === 'en' ? '' : 'details-container-ar')
          },
          _react2.default.createElement(
            'div',
            { className: 'details' },
            _react2.default.createElement(
              'p',
              { className: 'bold-title ' + (language === 'en' ? '' : 'ar') },
              localization.contact
            ),
            providerInfo.providerNumber ? _react2.default.createElement(
              'p',
              {
                className: 'light-detail ' + (language === 'en' ? '' : 'ar ar-phone')
              },
              '' + providerInfo.providerNumber
            ) : '',
            addressString ? _react2.default.createElement(
              'p',
              { className: 'light-detail ' + (language === 'en' ? '' : 'ar') },
              addressString
            ) : ''
          )
        )
      )
    )
  );
};

PrintInvoiceForm.propTypes = process.env.NODE_ENV !== "production" ? {
  printInvoiceDetails: _propTypes2.default.object,
  localization: _propTypes2.default.object,
  language: _propTypes2.default.string
} : {};

exports.default = PrintInvoiceForm;
module.exports = exports['default'];